module.exports = __webpack_public_path__ + "static/Google-Podcasts-e2104ff4c83685ed89f168201ddd3015.png";